import React from 'react';
import * as axios from 'axios';
import { Picture } from 'react-responsive-picture';

import Input from '../../components/Input';
import Checkbox from '../../components/Checkbox';
import Share from '../../components/Share';

import './styles.scss';

const result = [
  {
    title: "Вы — как брокколи на ужин",
    text: "Классный, но для узкого круга избранных. Поздравить с днём рождения спустя месяц? Лучше поздно, чем никогда! Главное — внимание."
  },
  {
    title: "Вы — как облачко в знойный день",
    text: "С радостью приходите на помощь, но иногда прячетесь. Легко встретитесь поболтать за чаем или придёте на вечеринку — но чур, не чаще раза в месяц!"
  },
  {
    title: "Вы – как сладкий пончик",
    text: "Если вы в компании, значит, сегодня вечеринка! Вас любят все: причём не только люди, но даже пёсики и котики."
  }
];

class Result extends React.Component {
    state = {
      isAgreeChekedError: false,
      isEmailError: false,
      isSuccess: false,
    }

    componentDidMount() {
      window.xray('user_score', JSON.stringify(this.props.result));
      window.dataLayer.push({'event': 'final'});
    }

  sendEmail = (e) => {
      e.preventDefault();

      const form = e.target.tagName.toLowerCase() === 'form' ? e.target : e.target.form;
      const emailField = form.querySelector('[name="email"]');
      const agree = form.querySelector('[name="agree"]');
      const pattern = /^[-\w.]+@([A-z0-9][-A-z0-9]+\.)+[A-z]{2,4}$/;

      const checked = agree.checked;
      const validEmail = emailField.value && pattern.test(emailField.value);

      this.setState({
        isAgreeChekedError: !checked,
        isEmailError: !validEmail
      });

      if (!checked || !validEmail) return;

      const instance = axios.create({
        withCredentials: true,
        baseURL: 'https://marusia.mail.ru/mailer/update/',
      });

      instance.post(emailField.value)
          .then(response => {
            this.setState({
              isSuccess: true
            });
            window.xray('email_submit', emailField.value);
            window.dataLayer.push({'event': 'sendform'});
          });
    }

    checkErrorCheckbox = (value) => {
      this.setState({
        isAgreeChekedError: !value
      });
      window.xray('agree_checkbox', JSON.stringify(value));
    }

    render() {
        const sum = this.props.result.reduce((a, b) => a + b, 0);
        let typeResult = 0;

        if (sum > 8 &&  sum < 12) {
          typeResult = 1;
        }

        if (sum >= 12) {
          typeResult = 2;
        }

        return (
          <div className="result">
        		<h2 className="result__title">
              { result[typeResult].title }
            </h2>
        		<p className="result__text">{ result[typeResult].text }</p>
        		<div className="result__img">
              <Picture
                sources = {[
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-1024.png 1x, ./static/media/result/result-${typeResult + 1}-1024@2x.png 2x `,
                    media: "(max-width: 1439px)",
                  },
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-1440.png 1x, ./static/media/result/result-${typeResult + 1}-1440@2x.png 2x `,
                    media: "(min-width: 1440px) and (max-width: 1689px)",
                  },
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-1690.png 1x, ./static/media/result/result-${typeResult + 1}-1690@2x.png 2x `,
                    media: "(min-width: 1690px) and (max-width: 1919px)",
                  },
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-1920.png 1x, ./static/media/result/result-${typeResult + 1}-1920@2x.png 2x `,
                    media: "(min-width: 1920px) and (max-width: 2559px)",
                  },
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-2500.png 1x, ./static/media/result/result-${typeResult + 1}-2500@2x.png 2x `,
                    media: "(min-width: 2560px)",
                  },
                  {
                    srcSet: `./static/media/result/result-${typeResult + 1}-2500.png 1x, ./static/media/result/result-${typeResult + 1}-2500@2x.png 2x`
                  }
                ]}
                src={`./static/media/result/result-${typeResult + 1}-2500.png`}
                alt={result[typeResult].title}
              />
        		</div>

        		<div className="result-form">
        			<div className="result-form__title">
                Ура, можно участвовать в розыгрыше <a href="https://capsula.mail.ru/?utm_source=site&utm_medium=landing&utm_campaign=friends_day" target="_blank" rel="noopener noreferrer">Капсулы</a>!<br />
                Не забудьте оставить почту и поделиться результатом<br />
                в соцсети.  Итоги — 11 августа.
              </div>
        			<div className="result-form__row">
        				<form className="result-form__box">
        					<div className={`result-form__fieldbox ${this.state.isSuccess ? ' -success' : ''}`}>
                    <div>
                      <Input
                        type="text"
                        name="email"
                        class={`result-form__field ${this.state.isEmailError ? ' -error' : ''}`}
                        placeholder="Е-mail" />
                    </div>
        						<button type="submit" className="result-form__button" onClick={this.sendEmail}>Отправить</button>
        					</div>
                  {this.state.isEmailError && (
                      <div className="result-form__field-error">Некорректный email</div>
                  )}
                  { !this.state.isSuccess &&
                    <label className={`result-form__checkbox ${this.state.isAgreeChekedError ? ' -error' : ''}`}>
                      <Checkbox
                        type="checkbox"
                        name="agree"
                        value="agree"
                        handleChange={this.checkErrorCheckbox} />
          						<span>я&nbsp;ознакомлен (-а) с&nbsp;<a href="./static/files/Pravila_Aktsii_Ko_Dnyu_Druzei_774_Final.pdf" target="_blank" rel="noopener noreferrer" data-xray-click="terms_link">правилами</a> акции и&nbsp;даю согласие на&nbsp;обработку персональных данных.</span>
          					</label>
                  }
                  { this.state.isSuccess &&
                    <div className="result-form__success">Готово! Итоги – 11 августа в <a href="https://vk.com/marusiaproject" target="_blank" rel="noopener noreferrer"  data-xray-click="vk_link">группе VK</a> </div>
                  }
        				</form>
                <Share result={typeResult} />
        			</div>
              <div className="result__logo"></div>
        		</div>

        	</div>
        )
    }
}

export default Result;
